export const designTypeIds = {
  systemScaffold: '35649535-bf17-4878-8e12-01bd3b20385e',
  tg20WithDesignInput: 'afb99244-9283-4e72-8b4c-8ce51c6c7690',
  designNumber: 'e62211d5-a494-4eeb-b6aa-af4b0e4eadef',
  tg20: '3b64a45c-a873-45ed-88f9-d203a2d293e9'
};
